import { themeColors } from "../../themeColors";
/**
 * @file   src\mobile\pages\Inapp.js
 * @brief  This file is responsible for handling notifications page in mobile view
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import {
  getInAppNotications,
  updateInAppDeleteStatus,
} from "../../services/introductionService";
import {
  getLocalStorage,
  loggedInUser,
  setBodyBackgroundGrey,
} from "../../helpers/common";
import { USER_INFO_KEY } from "../../constants/common";
import NotificationComponent from "../components/inapp/v2/NotificationComponent";
import TopHeader from "../components/common/TopHeader";
import DeleteModal from "../components/common/DeleteModal";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";
import { usePremium } from "@/hooks";
import BackLinkButton from "../components/BackLinkButton";

const Inapp = () => {
  const [notificationList, setNotificationList] = useState([]);
  const user = loggedInUser();
  const navigate = useNavigate();
  if (!user) {
    navigate(pageURLs.mobileSignIn);
  }
  const UserId =
    _.get(user, "userInfo.userId", null) ||
    _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", null);

  const [deleteNotificationModal, setDeleteNotificationModal] = useState(false);
  const handleDeleteNotificationPopupClose = () =>
    setDeleteNotificationModal(false);
  const [isLoadNotificationList, setLoadNotificationList] = useState(false);

  const { shouldToggleColor } = usePremium();

  // in-app notification
  useEffect(() => {
    console.log(UserId);
    if (UserId) {
      getNotificationList();
    }
  }, [UserId]);

  useEffect(() => {
    setBodyBackgroundGrey();
  }, []);
  /**
   * To get notifications list
   */
  const getNotificationList = async () => {
    setLoadNotificationList(false);

    await getInAppNotications().then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);

        if (response.errorCode === 0) {
          setNotificationList(list);
        }
        setLoadNotificationList(true);
      } else {
        setLoadNotificationList(true);
      }
    });
  };

  /**
   * To handle notifications deletion
   */
  const updateInAppDeleteStatusOnClick = async () => {
    const userId = _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", "");
    let notificationId = null;
    let subjectType = null;
    let deleteStatus = true;
    let deleteType = 2;
    await updateInAppDeleteStatus(
      notificationId,
      deleteStatus,
      userId,
      deleteType,
      subjectType,
    ).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          setDeleteNotificationModal(false);
          setNotificationList([]);
        }
      }
    });
  };

  const onDeleteInappNotification = () => {
    setDeleteNotificationModal(true);
  };

  return (
    <>
      <div className="gitcha-main-wrapper pb-0 h-100 bg-white">
        <div className="content-wrapper vh-100 android-h-fix">
          <TopHeader
            variant={"threeComp"}
            outerClassname="bg-white"
            topClassName="w-100 flex-column top-three-comp-headerborder"
            bottomClassName="w-100"
          >
            <BackLinkButton
              shouldToggleColor={shouldToggleColor}
              to="/mobile/home"
            />

            <div className={shouldToggleColor ? "heading-premium" : "heading"}>
              Notifications
            </div>
            <div className="p-0 toplinks-mobile">
              {notificationList.length > 0 && (
                <div
                  className="topbar-links notif-delete-btn"
                  onClick={() => {
                    onDeleteInappNotification();
                  }}
                  onKeyDown={() => {
                    onDeleteInappNotification();
                  }}
                  role="button"
                ></div>
              )}
            </div>
          </TopHeader>
          <div className="inner-layout-content-new h-100 bg-grey-variant ">
            {notificationList.length == 0 && isLoadNotificationList && (
              <div className="no-data-txt h-100 d-flex align-items-center justify-content-center flex-column">
                <p className="m-0 text-center">No new notifications </p>
              </div>
            )}
            <div>
              <div className="notif-content-wrapper pt-0">
                <NotificationComponent
                  notificationListData={notificationList}
                  reloadNotificationList={() => {
                    getNotificationList();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteModal
        show={deleteNotificationModal}
        onHide={handleDeleteNotificationPopupClose}
        title={"Are you sure you want to delete all notifications?"}
        message={""}
        buttonText={"Confirm"}
        handleConfirm={updateInAppDeleteStatusOnClick}
      />
    </>
  );
};

export default Inapp;
